import { currentHousehold } from '@/lib/currentHousehold'
import { queryClient } from '@/lib/queryClient'

interface SignOutCapable {
  signOut: (options?: { redirectUrl?: string }) => Promise<unknown>
}

/** The one place every sign-out flow in the app should go through. Clerk's signOut() only
 *  tears down the session — it doesn't know about our locally-cached household selection or
 *  the react-query cache, both keyed the same regardless of which Clerk user is signed in.
 *  Without this, signing out and back in as a *different* account in the same browser tab
 *  would still send the previous account's household id (403 NOT_A_HOUSEHOLD_MEMBER) and could
 *  serve its cached data. */
export async function signOutAndReset(clerk: SignOutCapable, redirectUrl: string) {
  currentHousehold.clear()
  queryClient.clear()
  await clerk.signOut({ redirectUrl })
}
